export default __webpack_public_path__ + "static/media/card1.5dbd25de.jpg";